import React from "react"

import Layout from "../layout"
import SEO from "../components/seo"
import { LetsDeal } from "../components/formPage/LetsDeal"

const LetsDealForm = ({ location }) => {
  return (
    <Layout>
      <SEO title="Lets Deal Formulär" />
      <LetsDeal />
    </Layout>
  )
}

export default LetsDealForm
